// extracted by mini-css-extract-plugin
export default {"root":"AddGroupModal_root__Yh+hC","tile":"AddGroupModal_tile__Xp21I","mandatory":"AddGroupModal_mandatory__BxBwH","btnsContainer":"AddGroupModal_btnsContainer__6wBAL"};